import { Map } from 'immutable';

import * as types from './types';
import { serializeMultiActivityData } from './utils';
import { CHARTS_DATA_PERIOD, CHARTS_NUMBER_OF_PERIODS } from './constants';

const initialState = Map({
  loading: true,
  results: [],
});

const activityReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_ORGANIZATION_ACTIVITY.SUCCESS: {
      return state.withMutations((mutable) => {
        const data = serializeMultiActivityData(
          payload, CHARTS_DATA_PERIOD, CHARTS_NUMBER_OF_PERIODS,
        );
        mutable.set('results', data);
        mutable.set('loading', false);
      });
    }
    case types.GET_ORGANIZATION_ACTIVITY.FAILURE:
      return state.set('loading', true);
    default:
      return state;
  }
};

export default activityReducer;
